import React from 'react'
import '../../styles/admission/main.css';

const Main = () => {
  return (
    <div className="admission-registration">
      <div className="container main-box">
        <div className="box">
          <div className="col-lg-4 col-sm-12">
            <div className="image">
              <span>Admission/ registration</span>
              <img src="../assets/images/admission-back.jpg" alt="" />
            </div>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className="links">

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://ccsuniversityadm.samarth.edu.in/" target="blank">
                    <p>
                      CAMPUS / COLLEGE ADMISSION PORTAL 2025-26 (UG/PG/Certificate/Diploma/PG Diploma)<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="http://scriet.ccsuforms.in/" target="blank">
                    <p>REGISTRATION FORM FOR B.TECH., M.C.A. , M.B.A. AND M.TECH. 2025-26</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/05/University%20Campus%20Brochure%202025-26%20(3).pdf" target="blank">
                    <p>University Campus Admission Brochure 2025-2026</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/06/College%20Brochure%202025-26%20Updated%20on%2023-06-2025.pdf" target="blank">
                    <p>College Admission Brochure 2025-2026</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/05/Anti-Ragging%20Undertaking.pdf" target="blank">
                    <p>Anti-Ragging Undertaking</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/05/Pradhan%20Mantri%20Vidyalaxmi%20Scheme.pdf" target="blank">
                    <p>Pradhan Mantri Vidyalaxmi Scheme</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://ccsucbtexam.in/" target="blank">
                    <p>APPLICATION FORM FOR PHD ADMISSION</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="http://entrance.ccsuforms.in/" target="blank">
                    <p>
                      Registration/ Application form for admission through entrance test in university campus & affiliated colleges 2025-2026 (M.ED, B.PED, M.PED, and LLM)
                    </p>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Main;